export const INITIAL_RATING_ID = 388;
export const INITIAL_YEAR = 2023;
export const RATINGS_TRID = 47049;
export const TITLE = 'Рейтинг лучших работодателей России';
export const DESCRIPTIONS = {
    2023: `В новый рейтинг лучших работодателей России вошли 125 компаний. Согласно методологии, разработанной в 2021 году, мы оценивали участников по основным элементам ESG-повестки и не присваивали им места, а распределили их по четырем группам: «Платина», «Золото», «Серебро» и «Бронза».`,
    2024: `В новый рейтинг лучших работодателей России вошли 168 компаний. Согласно методологии, разработанной в 2021 году, мы оценивали участников по основным элементам ESG-повестки и не присваивали им места, а распределили по четырем группам: «Платина», «Золото», «Серебро» и «Бронза». В каждой группе компании расположены в алфавитном порядке.`,
};
export const ABOUT_CONTENT = {
    texts: [
        'Первый рейтинг лучших работодателей России редакция Forbes выпустила в&nbsp;2019&nbsp;году. Тогда он&nbsp;был, по&nbsp;сути, HR-премией и&nbsp;на&nbsp;итоговый балл в&nbsp;основном влияли заработные платы и&nbsp;социальный пакет. Нынешняя методология была разработала в&nbsp;2021-ом совместно с&nbsp;компанией KPMG (с&nbsp;2022 года российский офис работает под брендом Kept). Мы&nbsp;учли возросшее в&nbsp;мире влияние ESG-повестки и&nbsp;оцениваем компании по&nbsp;большому набору метрик, объединенных в&nbsp;три группы: &laquo;Сотрудники и&nbsp;общество&raquo; (S), &laquo;Экология&raquo; (E) и&nbsp;&laquo;Корпоративное управление&raquo; (G).',
    ],
    peoples: [
        {
            title: 'Жюри',
            list: [
                {
                    post: 'Директор &laquo;Экологический союза&raquo;',
                    name: 'Юлия Грачева',
                },
                { post: 'Директор по&nbsp;персоналу корпоративных функций&nbsp;VK', name: 'Артём Попов' },
                { post: 'Директор департамента устойчивого развития &laquo;Росатома&raquo;', name: 'Полина Лион' },
                {
                    post: 'Управляющий директор&nbsp;&mdash; начальник управления HR-бренда, маркетинга и&nbsp;коммуникаций &laquo;Сбера&raquo;',
                    name: 'Артём Фатхуллин',
                },
                { post: 'Менеджер по&nbsp;устойчивому развитию &laquo;Яндекса&raquo;', name: 'Дарья Мухортова' },
                { post: 'Директор по&nbsp;устойчивому развитию &laquo;Сибур Холдинга&raquo;', name: 'Максим Ремчуков' },
                { post: 'Руководитель по&nbsp;устойчивому развитию &laquo;Вымпелкома&raquo;', name: 'Евгения Чистова' },
                {
                    post: 'Руководитель отдела развития бренда работодателя ГК&nbsp;&laquo;Самолет&raquo;',
                    name: 'Игорь Мостовщиков',
                },
                {
                    post: 'Директор департамента управления брендом работодателя &laquo;Ростелекома&raquo;',
                    name: 'Юлия Терещенко',
                },
                { post: 'Директор по&nbsp;развитию You Social', name: 'Полина Савельева' },
                { post: 'Руководитель направления по&nbsp;устойчивому развитию Т-Банка', name: 'Татьяна Полякова' },
                { post: 'Вице-президента по&nbsp;кадрам и&nbsp;системе управления НЛМК', name: 'Михаил Архипов' },
                { post: 'Директор по&nbsp;маркетингу и&nbsp;коммуникациям Альфа-банка', name: 'Алексей Гиязов' },
                { post: 'Директор по&nbsp;развитию бренда работодателя X5&nbsp;Group', name: 'Мария Верномудрова' },
                { post: 'Директор департамента развития бренда работодателя S7&nbsp;Group', name: 'Игорь Волков' },
                {
                    post: 'Руководитель департамента по&nbsp;работе с&nbsp;персоналом&nbsp;&mdash; старший вице-президент ВТБ',
                    name: 'Глеб Ермаков',
                },
                {
                    post: 'Начальник центра по внедрению принципов устойчивого развития — вице-президент Газпромбанка',
                    name: 'Евгений Хилинский',
                },
            ],
        },
        {
            title: 'Над проектом работали',
            list: [
                { post: 'Заместитель главного редактора Forbes Russia', name: 'Дмитрий Яковенко' },
                { post: 'Менеджер по&nbsp;работе с&nbsp;партнерами Forbes Education', name: 'Александра Оруджова' },
                { post: 'Шеф-редактор Forbes.ru', name: 'Юля Сапронова' },
            ],
        },
    ],
};
export const METHODOLOGY_CONTENT = [
    {
        title: 'Какие данные мы собираем',
        text: 'Основной метод&nbsp;&mdash; анкетирование компаний. Каждый год Forbes рассылает анкету в&nbsp;более 100 крупнейших компаний и&nbsp;участников прошлых рейтингов. Также анкета публикуется на&nbsp;сайте Forbes, где ее&nbsp;может скачать и&nbsp;заполнить любая компания. Данные по&nbsp;крупнейшим публичным компаниям, не&nbsp;предоставившим данные, берутся из&nbsp;годовых отчетов и&nbsp;отчетов об&nbsp;устойчивом развитии.',
    },
    {
        title: 'Как рассчитывается величина баллов',
        formulas: [
            {
                text: 'Минимальное значение балла по&nbsp;каждому параметру&nbsp;&mdash; 0, максимальное&nbsp;&mdash; 100. При оценке количественных показателей балл по&nbsp;каждому параметру рассчитывается с&nbsp;помощью метода z-оценки, которая показывает относительный разброс параметра от&nbsp;среднего значения в&nbsp;выборке.',
                formulaMobile: 'Значение показателя − среднее значение по выборке  ÷  Стандартное отклонение по выборке  ×  25  +  50  =  Итоговый бал',
                formula: '      <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mi>Значение показателя − среднее значение по выборке</mi></mrow><mrow><mi>Стандартное отклонение по выборке</mi></mrow></mfrac><mo>&times;</mo><mn>25</mn><mo>+</mo><mn>50</mn><mo>=</mo><mi>Итоговый балл</mi></math>',
            },
            {
                text: 'Если баллы присваиваются по&nbsp;принципу: чем меньше параметр, тем выше балл (в&nbsp;случае с&nbsp;выбросами и&nbsp;использованием ресурсов), формула приобретает другой вид.',
                formulaMobile: 'Значение показателя − среднее значение по выборке  ÷  Стандартное отклонение по выборке  ×  (−25)  +  50  =  Итоговый бал',
                formula: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mi>Значение показателя − среднее значение по выборке</mi></mrow><mrow><mi>Стандартное отклонение по выборке</mi></mrow></mfrac><mo>&times;</mo><mo stretchy="false">(</mo><mo>&#8211;</mo><mn>25</mn><mo stretchy="false">)</mo><mo>+</mo><mn>50</mn><mo>=</mo><mi>Итоговый балл</mi></math>',
            },
        ],
    },
    {
        title: 'Какие группы метрик и с какими весами мы используем',
        text: 'Общий балл по&nbsp;каждой группе рассчитывается как среднее арифметическое баллов по&nbsp;входящим в&nbsp;нее метрикам.',
        olGrup: [
            {
                title: 'Сотрудники и общество',
                percent: '40',
                list: [
                    'Средняя зарплата',
                    'Корпоративное обучение',
                    'Социальный пакет',
                    'Травматизм',
                    'Текучесть кадров',
                    'Рабочие места',
                    'Благотворительность и инвестиции в инфраструктуру',
                    'Работа с сотрудниками',
                    'Системные меры',
                ],
            },
            {
                title: 'Экология',
                percent: '40',
                list: [
                    'Негативное воздействие и плата за его компенсацию',
                    'Рациональное использование ресурсов',
                    'Расходы на охрану окружающей среды',
                    'Экологическая политика',
                    'Климатическая политика',
                ],
            },
            {
                title: 'Корпоративное управление ',
                percent: '20',
                list: ['Гендерное равенство', 'Комплаенс', 'Контрольная среда', 'Прозрачность', 'Работа с контрагентами'],
            },
        ],
    },
    {
        title: 'Как присваиваются баллы',
        olList: [
            {
                title: 'Сотрудники и общество',
                list: [
                    {
                        subtitle: 'Средняя зарплата',
                        blocks: [
                            {
                                text: 'Компании оцениваются в зависимости от величины средней зарплаты в 2023 году. При расчете средней зарплаты не учитывается вознаграждение членов совета директоров и правления. Если нет данных о размере средней зарплаты, используется средняя по отрасли по данным Росстата.',
                            },
                        ],
                        // footerText:
                        //   'Вторая часть балла зависит от&nbsp;того, менялась&nbsp;ли средняя зарплата в&nbsp;компании с&nbsp;начала года. Если она сокращалась (в&nbsp;том числе за&nbsp;счет перевода сотрудников на&nbsp;неполную рабочую неделю или в&nbsp;простой), компания получает 0&nbsp;баллов, если зарплата не&nbsp;менялась&nbsp;&mdash; 50&nbsp;баллов, если выросла&nbsp;&mdash; 100&nbsp;баллов.',
                    },
                    {
                        subtitle: 'Корпоративное обучение',
                        blocks: [
                            {
                                text: 'Балл формируется на основе двух показателей:',
                                sublist: [
                                    {
                                        li: '50% — доля сотрудников компании, в 2023 году прошедших обучение в расчете на среднесписочную численность персонала',
                                    },
                                    {
                                        li: '50% — затраты на обучение сотрудников в 2023 году в расчете на среднесписочную численность персонала',
                                    },
                                ],
                            },
                        ],
                        footerText: 'Не&nbsp;учитывается обязательное обучение, предусмотренное отраслевой спецификой, а&nbsp;также обучение технике безопасности, промышленной безопасности.',
                    },
                    {
                        subtitle: 'Социальный пакет',
                        blocks: [
                            {
                                text: 'Балл формируется на основе трех показателей:',
                                sublist: [
                                    {
                                        li: 'Затраты на ДМС и социальные программы в 2023 году в расчете на среднесписочную численность персонала',
                                    },
                                    {
                                        li: 'Доля сотрудников, охваченных корпоративными спортивными программами.',
                                    },
                                    {
                                        li: 'Количество составляющих социальной политики:',
                                        ssublist: [
                                            'ДМС',
                                            'корпоративные пенсии',
                                            'санаторно-курортное лечение',
                                            'увеличенный отпуск',
                                            'страхование жизни и здоровья сотрудников',
                                            'материальная помощь',
                                            'возможность работать неполный рабочий день или удаленно',
                                            'жилищные программы для семей сотрудников, льготная ипотека',
                                            'помощь с переездом',
                                            'компенсация затрат на питание',
                                            'компенсация затрат на транспорт',
                                            'компенсация затрат на связь',
                                            'льготы от компаний-партнеров',
                                            'спортивные программы',
                                            'поддержка пенсионеров',
                                            'детские сады для детей сотрудников',
                                            'увеличенные больничные',
                                            'льготные кредиты',
                                            'льготы на образование для молодых сотрудников',
                                        ],
                                    },
                                ],
                            },
                        ],
                        footerText: 'В&nbsp;зависимости от&nbsp;количества составляющих компании получают&nbsp;33 (3&nbsp;и&nbsp;меньше), 50&nbsp;(от&nbsp;4&nbsp;до&nbsp;6), 70&nbsp;(от&nbsp;7&nbsp;до&nbsp;10), 100 (больше&nbsp;10) баллов.',
                    },
                    {
                        subtitle: 'Травматизм',
                        blocks: [
                            {
                                text: 'Балл формируется на основе двух показателей:',
                                sublist: [
                                    {
                                        li: '50%&nbsp;&mdash; величина коэффициента LTIFR в&nbsp;2023&nbsp;году. Компании получают 100 баллов при LTIFR &lt; 0,3, 66&nbsp;баллов при 0,3 &lt; LTIFR &lt; 0,7, 33&nbsp;балла при LTIFR &gt; 0,7',
                                    },
                                    {
                                        li: '50%&nbsp;&mdash; динамика коэффициента LTIFR в&nbsp;2021&minus;2023&nbsp;годах. Если коэффициент сократился компания получает 100&nbsp;баллов, в&nbsp;противном случае&nbsp;&mdash; 0&nbsp;баллов',
                                    },
                                ],
                            },
                        ],
                        footerText: 'При наличии смертельных случаев собственного персонала или персонала подрядчиков в&nbsp;2023 году балл &laquo;травматизм&raquo; равен 0. Расчет балла по&nbsp;коэффициенту LTIFR производится только для производственных компаний или компаний, условия работы в&nbsp;которых предполагают риск травматизма.',
                    },
                    {
                        subtitle: 'Текучесть кадров',
                        blocks: [
                            {
                                text: 'Компании оцениваются исходя из показателя текучести кадров (общее количество уволенных за отчетный период в отношении к среднесписочной численности персонала).',
                            },
                        ],
                    },
                    {
                        subtitle: 'Рабочие места',
                        blocks: [
                            {
                                text: 'Балл зависит от&nbsp;того, как менялся штат компании за&nbsp;полный 2023&nbsp;год. При этом все компании делятся на&nbsp;три группы в&nbsp;зависимости от&nbsp;величины штата: меньше 10&nbsp;000&nbsp;сотрудников, от&nbsp;10&nbsp;000 сотрудников до&nbsp;100&nbsp;000&nbsp;сотрудников, больше 100&nbsp;000&nbsp;сотрудников. Компании, чей штат за&nbsp;год сократился или не&nbsp;изменился, получают 0&nbsp;баллов.',
                                // formula:
                                //   '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>100</mn><mo>+</mo><mi>z-оценка</mi></mrow><mrow><mn>2</mn></mrow></mfrac><mo>=</mo><mi>Итоговый балл</mi></math>',
                            },
                        ],
                    },
                    {
                        subtitle: 'Благотворительность и инвестиции в инфраструктуру',
                        blocks: [
                            {
                                text: 'Балл зависит от&nbsp;величины взносов на&nbsp;благотворительность, поддержку спорта, религии, культуры и&nbsp;аналогичных затрат, а&nbsp;также инвестиций, напрямую не&nbsp;связанных с&nbsp;бизнесом компании, например, на&nbsp;строительство больниц, спортивных или культурных объектов в&nbsp;регионах присутствия, поддержку образования и&nbsp;развития новых технологий. Инвестиции оцениваются за&nbsp;2022-2023 годы в&nbsp;отношении к&nbsp;суммарной выручке за&nbsp;этот период. Промышленные компании по&nbsp;этому показателю оцениваются отдельной группой от&nbsp;компаний из&nbsp;других секторов. Для непроизводственных компаний учитывается также денежное выражение пожертвованных товаров и&nbsp;услуг, а&nbsp;также благотворительности, реализованной через совместные программы или разработанные компанией (например, в&nbsp;сфере&nbsp;IT) сервисы.',
                            },
                        ],
                    },
                    {
                        subtitle: 'Работа с сотрудниками',
                        blocks: [
                            {
                                text: 'Балл формируется на основе следующих показателей:',
                                sublist: [
                                    {
                                        li: '50% балла зависит от&nbsp;доли корпоративных волонтеров в&nbsp;2023&nbsp;году, а&nbsp;также доли нанятых сотрудников с&nbsp;инвалидностью и&nbsp;нанятых по&nbsp;итогам стажировок',
                                    },
                                    {
                                        li: '50% балла зависит от&nbsp;наличия у&nbsp;компании следующих элементов программ well-being и&nbsp;работы с&nbsp;молодежью:',
                                        ssublist: [
                                            'помощь в&nbsp;карьерном развитии, создание центров компетенций по&nbsp;передаче экспертизы от&nbsp;старших работников',
                                            'подготовка к&nbsp;выходу на&nbsp;пенсию',
                                            'переквалификация и&nbsp;освоение новых актуальных специализаций для сотрудников, планируемых к&nbsp;сокращению в&nbsp;перспективе',
                                            'наличие стажировок для молодых кадров, стипендиальные программы',
                                            'удержание молодых кадров в&nbsp;малых и&nbsp;средних городах',
                                            'мониторинг эмоционального фона среди сотрудников и&nbsp;программы психологической помощи, вебинары с&nbsp;психологами',
                                            'вовлечение в&nbsp;повестку устойчивого развития (например, через информирование о&nbsp; шеринг-экономике, ответственном потреблении)',
                                            'корпоративное волонтерство',
                                        ],
                                    },
                                ],
                            },
                        ],
                        footerText: 'В&nbsp;зависимости от&nbsp;количества элементов компании получают&nbsp;33 (2&nbsp;элемента), 66&nbsp;(менее 5), 100 (5&nbsp;и&nbsp;более) баллов.',
                    },
                    {
                        subtitle: 'Системные меры',
                        blocks: [
                            {
                                text: 'Балл зависит от наличия у компании следующих элементов:',
                                sublist: [
                                    { li: 'стратегия управления персоналом' },
                                    { li: 'политика в области управления персоналом' },
                                    { li: 'политика в области соблюдения прав человека' },
                                    { li: 'политика в области разнообразия и инклюзивности' },
                                    { li: 'политика в области спонсорства и благотворительности' },
                                    { li: 'коллективное соглашение' },
                                    { li: 'политика или программы по взаимодействию с заинтересованными сторонами' },
                                    { li: 'политика в области охраны труда и производственной безопасности' },
                                ],
                            },
                        ],
                        footerText: 'В зависимости от количества элементов компании получают 33 (1 элемент), 66 (менее 3), 80 (3-6) или 100 (все элементы) баллов.',
                    },
                ],
            },
            {
                title: 'Экология',
                text: 'Все компании делятся по конкретным отраслям, внутри которых проводится сравнение. При сравнении количественных показателей берется их отношение к выручке.',
                list: [
                    {
                        subtitle: 'Негативное воздействие и плата за его компенсацию',
                        blocks: [
                            {
                                text: 'Для производстaвенных компаний балл формируется исходя из следующих показателей:',
                                sublist: [
                                    { li: 'выбросы парниковых газов' },
                                    { li: 'выбросы оксида азота' },
                                    { li: 'выбросы диоксида серы' },
                                    { li: 'величина выплат за&nbsp;негативное воздействие на&nbsp;окружающую, среду' },
                                    { li: 'раскрытие компании данных об&nbsp;углеродном следе (0&nbsp;или, 100&nbsp;баллов)' },
                                    { li: 'объем образованных отходов' },
                                    { li: 'доля перерабатываемых отходов' },
                                ],
                            },
                        ],
                        footerText: 'Компании из&nbsp;непроизводственных отраслей оцениваются исходя из&nbsp;уровней выбросов парниковых газов, раскрытия информации об&nbsp;углеродном следе, а&nbsp;также объемов образующихся отходов и&nbsp;доли их&nbsp;переработки.',
                    },
                    {
                        subtitle: 'Рациональное использование ресурсов',
                        blocks: [
                            {
                                text: 'Компании оцениваются исходя из:',
                                sublist: [
                                    { li: 'потребления воды' },
                                    { li: 'потребления энергии' },
                                    { li: 'доли ВИЭ в общем энергетическом балансе' },
                                ],
                            },
                        ],
                    },
                    {
                        subtitle: 'Расходы на охрану окружающей среды',
                        blocks: [
                            {
                                text: 'Компании оцениваются исходя из&nbsp;величины расходов на&nbsp;охрану окружающей среды в&nbsp;2022-2023 годах по&nbsp;отношению к&nbsp;выручке за&nbsp;аналогичный период. В&nbsp;структуре расходов не&nbsp;учитываются штрафы и&nbsp;выплаты за&nbsp;негативное воздействие на&nbsp;окружающую среду',
                            },
                        ],
                    },
                    {
                        subtitle: 'Экологическая политика',
                        blocks: [
                            {
                                text: 'Компании оцениваются исходя из наличия в их политиках следующих элементов:',
                                sublist: [
                                    { li: 'экологическая политика' },
                                    { li: 'экологическая стратегия' },
                                    { li: 'наличие КПЭ/целей в области охраны окружающей среды' },
                                    { li: 'политика в области биоразнообразия' },
                                    { li: 'программа в области биоразнообразия' },
                                    { li: 'наличие сертификации по ISO14001' },
                                    { li: 'оценка экологических рисков контрагентов' },
                                    { li: 'наличие процесса управления экологическими рисками' },
                                    { li: 'наличие сертификации по программам «Листок жизни», «Лесной эталон», One Proof' },
                                ],
                            },
                            {
                                text: 'Для непроизводственных компаний также учитывается:',
                                sublist: [
                                    { li: 'наличие программы «зеленый офис»' },
                                    { li: 'наличие сертифицированных объектов эксплуатации (BREAM, LEED)' },
                                ],
                            },
                            {
                                text: 'Для финансовых компаний также учитывается:',
                                sublist: [
                                    { li: 'тестирование подверженности кредитного и инвестиционного портфеля экологическим рискам' },
                                    { li: 'оценка экологических рисков при формировании финансового продукта' },
                                    { li: 'интеграция оценки экологических рисков в процесс управления рисками' },
                                ],
                            },
                        ],
                        footerText: 'В&nbsp;зависимости от&nbsp;количества элементов компании получают&nbsp;33 (1), 66&nbsp;(менее 3), 80 (3-5) или 100 (все элементы) баллов.',
                    },
                    {
                        subtitle: 'Климатическая политика',
                        blocks: [
                            {
                                text: 'Компании оцениваются исходя из наличия в их политиках следующих элементов:',
                                sublist: [
                                    { li: 'климатическая политика' },
                                    { li: 'климатическая стратегия' },
                                    { li: 'политика в области энергоэффективности' },
                                    { li: 'программа в области энергоэффективности' },
                                    { li: 'использование ВИЭ' },
                                    { li: 'наличие КПЭ/целей в области климата/выбросов парниковых газов/энергоэффективности' },
                                    { li: 'оценка климатических рисков контрагентов' },
                                    { li: 'наличие процесса управления климатическими рисками' },
                                ],
                            },
                            {
                                text: 'Для финансовых компаний также учитывается:',
                                sublist: [
                                    { li: 'тестирование подверженности кредитного и инвестиционного портфеля климатическим рискам' },
                                    { li: 'принятие решений о формировании финансового продукта с учетом оценки климатических рисков' },
                                    { li: 'интеграция оценки климатических рисков в процесс управления рисками' },
                                ],
                            },
                        ],
                        footerText: 'В&nbsp;зависимости от&nbsp;количества элементов компании получали&nbsp;33 (1), 66&nbsp;(менее 3), 80 (3-5) или 100 (все элементы) баллов.',
                    },
                ],
            },
            {
                title: 'Корпоративное управление',
                list: [
                    {
                        subtitle: 'Гендерное равенство',
                        blocks: [
                            {
                                text: 'Компания получает 0&nbsp;баллов, если среди сотрудников руководящего уровня представлены только мужчины или женщины, 100 баллов при равенстве полов (доля меньшей группы может также находится в&nbsp;диапазоне 40-49%) и&nbsp;50&nbsp;&mdash; при другой пропорции.',
                            },
                        ],
                        footerText: '',
                    },
                    {
                        subtitle: 'Комплаенс',
                        blocks: [
                            {
                                text: 'Компании оцениваются на наличие следующих элементов:',
                                sublist: [
                                    { li: 'политика в области комплаенс' },
                                    { li: 'должность комплаенс-офицера' },
                                    { li: 'политика в области противодействия коррупции' },
                                    {
                                        li: 'политики противодействия отмыванию доходов, полученных преступным путем, и финансирования терроризма',
                                    },
                                    { li: 'политики противодействия распространению инсайдерской информации' },
                                    { li: 'кодекс деловой этики' },
                                    { li: 'наличие горячей линии' },
                                ],
                            },
                        ],
                        footerText: 'В&nbsp;зависимости от&nbsp;количества элементов компании получают&nbsp;33 (1), 66&nbsp;(менее 3), 80 (3-5) или 100 (все элементы) баллов.',
                    },
                    {
                        subtitle: 'Контрольная среда',
                        blocks: [
                            {
                                text: 'Компании оцениваются на наличие следующих элементов:',
                                sublist: [
                                    { li: 'кодекс корпоративного управления' },
                                    { li: 'политика в области внутреннего аудита' },
                                    { li: 'подчиненность внутреннего аудита совету директоров' },
                                    { li: 'политика в области управления рисками' },
                                    { li: 'наличие chief risk officer (CRO)' },
                                    { li: 'подчиненность CRO генеральному директору и СД' },
                                    { li: 'комитет по аудиту при СД' },
                                    { li: 'комитета по кадрам и вознаграждениям при СД' },
                                ],
                            },
                        ],
                        footerText: 'В&nbsp;зависимости от&nbsp;количества элементов компании получают&nbsp;33 (1), 66&nbsp;(менее 3), 80 (3-5) или 100 (все элементы) баллов',
                    },
                    {
                        subtitle: 'Прозрачность',
                        blocks: [
                            {
                                text: 'Компании оцениваются на&nbsp;наличие следующих элементов:',
                                sublist: [
                                    { li: 'опубликованный отчет об&nbsp;устойчивом развитии' },
                                    { li: 'единая стратегия устойчивого развития' },
                                    { li: 'участие в&nbsp;отраслевых организациях' },
                                ],
                            },
                        ],
                        footerText: 'В&nbsp;зависимости от&nbsp;количества элементов компании получают&nbsp;33 (1), 66 (2) или 100 (все элементы) баллов',
                    },
                    {
                        subtitle: 'Работа с контрагентами',
                        blocks: [
                            {
                                text: 'Компании оцениваются на наличие следующих элементов:',
                                sublist: [
                                    { li: 'политика в области контроля за контрагентами в цепочке поставок' },
                                    { li: 'наличие КПЭ/целей в области контроля за контрагентами в цепочке поставок' },
                                    { li: 'оценка экологических и социальных параметров в контрактах на поставки и услуги' },
                                    { li: 'обучение контрагентов' },
                                ],
                            },
                        ],
                        footerText: 'В&nbsp;зависимости от&nbsp;количества элементов компании получают&nbsp;33 (1), 66 (2) или 100 (3-4&nbsp;элемента) баллов',
                    },
                ],
            },
        ],
    },
    {
        title: 'Экспертная оценка',
        text: 'После расчета баллов по группам &laquo;Сотрудники и общество&raquo;, &laquo;Экология&raquo; и &laquo;Корпоративное управление&raquo; компании присваиваются соответствующие статусы:',
        ulMedals: [
            { position: 'platinum', text: 'Платиновый статус  — более 70 баллов' },
            { position: 'gold', text: 'Золотой статус — от 55 до 70 баллов' },
            { position: 'silver', text: 'Серебряный статус — от 40 до 54 баллов' },
            { position: 'bronze', text: 'Бронзовый статус — от 30 до 39 баллов' },
        ],
        footerText: 'Компании, набравшие менее 30&nbsp;баллов, в&nbsp;рейтинг шорт-лист рейтинга не&nbsp;попадают.<br/><br/>Жюри конкурса голосует за&nbsp;статус компании в&nbsp;рейтинге и&nbsp;имеет возможность повысить или понизить статус компании в&nbsp;рейтинге. Итоговое решение принимается большинством голосов. При равенстве голосов предпочтение отдается варианту с&nbsp;более высоким значением номинации. Во&nbsp;избежание конфликта интересов член жюри не&nbsp;может голосовать за&nbsp;компании, в&nbsp;которых он&nbsp;работает, инвестирует или является членом советом директоров.',
    },
];
/**
 * Create groups
 */
export function createGroups(rating) {
    const { field_values: fieldValues, fields, grouped, grouprange } = rating;
    if (!grouped || !grouprange || !fieldValues) {
        return [];
    }
    const columnsIds = fields?.map((field) => field.cf_id || -1) || [];
    const columnsSuffixes = fields?.reduce((fields, field) => {
        fields[field?.cf_id || ''] = field?.sub_str?.trim() || '';
        return fields;
    }, {}) || {};
    return grouprange.split(';').map((title) => {
        // Create grouped items
        let items = createGroupedItems(rating, title, columnsIds, columnsSuffixes);
        // Sort grouped items by position
        items.sort((a, b) => {
            const { value: valueA = 0 } = Object.values(a).find(({ lowerTitle }) => lowerTitle === '#') || {};
            const { value: valueB = 0 } = Object.values(b).find(({ lowerTitle }) => lowerTitle === '#') || {};
            return Number(valueA) - Number(valueB);
        });
        // Counting position within a group starting from the first one
        items = items.map((item, i) => {
            const positionField = Object.values(item).find(({ lowerTitle }) => lowerTitle === '#') || {};
            positionField.value = String(i + 1);
            return item;
        });
        return {
            title,
            items,
        };
    });
}
/**
 * Create grouped items
 */
export function createGroupedItems(rating, title, columnsIds, columnsSuffixes) {
    const { field_values: fieldValues, groupfieldid } = rating;
    if (!fieldValues) {
        return [];
    }
    return Object.values(fieldValues).reduce((values, rawItem) => {
        const groupTitle = rawItem?.values?.find((field) => Number(field.cf_id) === groupfieldid)?.string_val || '';
        if (!groupTitle || groupTitle !== title) {
            return values;
        }
        const { profile } = rawItem || {};
        const { properties } = profile || {};
        const industryProperty = properties?.find(({ title }) => (title?.trim()?.toLowerCase() || '') === 'отрасль');
        const industryTitle = industryProperty?.title?.trim() || '';
        const industryValue = industryProperty?.value?.trim() || '';
        values.push({
            /* eslint-disable-next-line */
            ['компания']: {
                id: 'company',
                isFloat: false,
                isHidden: false,
                isSelectable: false,
                isSortable: true,
                lowerTitle: 'компания',
                title: 'Компания',
                value: profile?.title?.trim() || '',
            },
            [industryTitle.toLowerCase() || 'отрасль']: {
                id: 'industry',
                isFloat: false,
                isHidden: false,
                isSelectable: true,
                isSortable: false,
                lowerTitle: industryTitle.toLowerCase(),
                title: industryTitle,
                value: industryValue,
            },
            ...createItemColumns(rawItem, columnsIds, columnsSuffixes),
        });
        return values;
    }, []);
}
/**
 * Create item columns
 */
export function createItemColumns(rawItem, columnsIds, columnsSuffixes) {
    if (!(columnsIds || []).length) {
        return {};
    }
    return columnsIds.reduce((columns, columnId) => {
        const column = rawItem.values?.find((value) => value.cf_id === columnId) || {};
        const id = String(column?.cf_id || '');
        const title = column?.field_title?.trim() || id || '';
        const lowerTitle = isPositionField(title) ? '#' : title.toLowerCase();
        const isHidden = (Boolean(Number(column?.is_hidden)) && !lowerTitle.includes('(скрытая)')) || lowerTitle === '#';
        const isSelectable = lowerTitle === 'штат (скрытая)';
        const isSortable = false;
        const suffix = columnsSuffixes[id];
        let isFloat = Boolean(Number(column?.is_float));
        let value = '';
        column.string_val = String(column?.string_val || '').trim();
        if (isFloat) {
            value = String(column?.float_val || '')
                .replace(/\s+/g, '')
                .replace(',', '.')
                .trim();
        }
        else {
            isFloat = !isNaN(Number(column.string_val.replace(/\s+/g, '')));
            value = column.string_val || '—';
            if (isFloat) {
                value = value.replace(/\s+/g, '');
            }
        }
        columns[lowerTitle] = {
            id,
            isHidden,
            isFloat,
            isSelectable,
            isSortable,
            lowerTitle,
            suffix,
            title,
            value,
        };
        return columns;
    }, {});
}
/**
 * Is postion field
 */
export function isPositionField(title = '') {
    return ['место', 'позиция'].includes(title.toLowerCase());
}
